import { fetchEmails } from './fetchEmails';
import { generateEmailExample } from './generateEmailExample';
import { getEmailTemplateList } from './getEmailTemplateList';
import { getSendGridDynamicTemplate } from './getSendGridDynamicTemplate';
import { getSendGridDynamicTemplates } from './getSendGridDynamicTemplates';
import { sendBulkEmailByCallerIds } from './sendBulkEmailByCallerIds';
import { sendBulkEmailByEmailAddresses } from './sendBulkEmailByEmailAddresses';
import { sendContactUsEmail } from './sendContactUsEmail';
import { sendVerificationEmail } from './sendVerificationEmail';

export const emailService = {
  generateEmailExample,
  fetchEmails,
  getEmailTemplateList,
  getSendGridDynamicTemplate,
  getSendGridDynamicTemplates,
  sendBulkEmailByCallerIds,
  sendBulkEmailByEmailAddresses,
  sendContactUsEmail,
  sendVerificationEmail,
};
